import React from "react";
import { Controller } from "react-hook-form";
import { FontEnum } from "../../utils/enums/FontEnum";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TextField } from "@mui/material";
import moment from "moment";


const ControllerDatePicker = ({
    name,
    control,
    defaultValue,
    label,
    placeholder,
    disabled = false,
    onChange,
    width = 250
}) => {

    const DatePickerTextField = (
        <TextField />
    );


    const getMomentValue = (value) => {
        if (value) {
            return moment(value);
        }
        else {
            return null;
        };
    };

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <Controller
                name={name}
                defaultValue={defaultValue || null}
                control={control}
                render={({ field, fieldState }) => (
                    <DatePicker
                        {...field}
                        id={name}
                        label={label}
                        sx={{ width: 300, borderRadius: 20 }}
                        format="DD.MM.YYYY"
                        value={getMomentValue(field.value)}
                        onChange={(e) => {
                            field.onChange(e);
                            if (onChange) {
                                onChange(e);
                            };
                        }}
                        disabled={disabled}
                        slotProps={{
                            textField: DatePickerTextField
                        }}
                        renderInput={(params) => (
                            DatePickerTextField
                        )}
                    />
                )}
            />
        </LocalizationProvider>
    );
};


export default ControllerDatePicker;


const styles = {
    inputStyle: {
        minWidth: "250px",
        height: "56px",
        backgroundColor: 'transparent',
        border: "1px solid #0000003b",
        borderRadius: 6,
        paddingInline: 12,
        fontFamily: FontEnum.TITILIUM_WEB,
    }
}